<template>
  <div class="modal">
    <FullBackdrop class="fenif-test">
      <div class="container">
        <h3 class="modal-title" style="color: red">{{ $t("report.title") }}</h3>

        <template v-if="fillingForm">
          <form @submit.prevent="reportAttempt">
            <div
              v-if="!$auth.check()"
              class="form-group"
              :class="{ error: $v.loginForm.userEmail.$error }"
            >
              <h4 style="margin-block-end: auto">
                {{ $t("report.form.field.email") }}
              </h4>
              <input
                type="email"
                :placeholder="$t('report.form.placeholder.email')"
                class="form-control"
                v-model="loginForm.userEmail"
                @input="$v.loginForm.userEmail.$touch"
                ref="userEmail"
              />
              <template v-if="$v.loginForm.userEmail.$error">
                <p class="error-message" v-if="!$v.loginForm.userEmail.email">
                  {{
                    $t("validations.email", {
                      field: $t("report.form.field.email"),
                    })
                  }}
                </p>
                <p
                  class="error-message"
                  v-if="!$v.loginForm.userEmail.required"
                >
                  {{
                    $t("validations.required", {
                      field: $t("report.form.field.email"),
                    })
                  }}
                </p>
              </template>
            </div>

            <div
              class="form-group"
              :class="{ error: $v.loginForm.reason.$error }"
            >
              <h4 style="margin-block-end: auto">
                {{ $t("report.form.field.reason") }}
              </h4>
              <textarea
                :placeholder="$t('report.form.placeholder.reason')"
                class="form-control textarea"
                v-model="loginForm.reason"
                @input="$v.loginForm.reason.$touch"
                @keyup="textAreaAdjust($refs.reason)"
                ref="reason"
              >
              </textarea>
              <template v-if="$v.loginForm.reason.$error">
                <p class="error-message" v-if="!$v.loginForm.reason.required">
                  {{
                    $t("validations.required", {
                      field: $t("report.form.field.reason"),
                    })
                  }}
                </p>
              </template>
              <p id="reason-advice">{{ $t("report.form.message_advice") }}</p>
            </div>

            <div class="messages">
              <div v-for="(errors, errorKey) in loginErrors" :key="errorKey">
                <p v-for="error in errors" :key="error">
                  {{ error }}
                </p>
              </div>
            </div>

            <div class="footer">
              <button class="btn-login" type="submit">
                {{ $t("report.title") }}
              </button>
              <button class="cancel active" @click="$emit('cancel')">
                {{ $t("dashboard.back") }}
              </button>
            </div>
          </form>
        </template>
        <template v-else>
          <h4>{{ endedRequestMessage }}</h4>
          <div class="footer">
            <button class="cancel active" @click="$emit('cancel')">
              {{ $t("dashboard.back") }}
            </button>
          </div>
        </template>
      </div>
    </FullBackdrop>
  </div>
</template>

<script>
import {
  required,
  minLength,
  email,
  maxLength,
  requiredIf,
} from "vuelidate/lib/validators";

import FullBackdrop from "./../../FullBackdrop";
import resources from "../../../resources";

const REASON_MAX_LENGTH = 500;

export default {
  components: { FullBackdrop },
  props: {
    modelId: {
      type: Number,
      required: true,
    },
    postId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loginForm: {
        userEmail: "",
        reason: "",
        modelId: "",
        postId: "",
      },
      loginErrors: {},
      fillingForm: true,
      endedRequestMessage: this.$t("report.response_message.waiting"),
      endedRequestTimer: null,
    };
  },
  methods: {
    textAreaAdjust(element) {
      element.style.height = "1px";
      element.style.height = 10 + element.scrollHeight + "px";
    },
    reportAttempt(e) {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.fillingForm = false;
      resources.postOption
        .report({
          userEmail: this.loginForm.userEmail,
          reason: this.loginForm.reason,
          modelId: this.modelId,
          postId: this.postId,
        })
        .then((response) => {
          switch (response.data.status) {
            case 201:
              this.endedRequestMessage = this.$t(
                "report.response_message.success"
              );
              break;

            case 422:
              this.endedRequestMessage = this.$t(
                "report.response_message.bad_request"
              );
              break;

            case 500:
              this.endedRequestMessage = this.$t(
                "report.response_message.error"
              );
              break;

            case 208:
              this.endedRequestMessage = this.$t(
                "report.response_message.already_reported"
              );
              break;

            default:
              this.endedRequestMessage = this.$t(
                "report.response_message.error"
              );
              break;
          }
        })
        .catch((error) => {
          this.endedRequestMessage = this.$t("report.response_message.error");
          console.log(error);
        })
        .finally(() => {
          this.endedRequestTimer = setTimeout(() => {
            this.$emit("cancel");
          }, 5000);
        });
    },
  },
  validations() {
    return {
      loginForm: {
        userEmail: {
          requiredIf: requiredIf(() => !this.$auth.check()),
          email,
          minLength: minLength(4),
        },
        reason: {
          required,
          maxLength: maxLength(REASON_MAX_LENGTH),
        },
      },
    };
  },
  mounted() {
    if (this.$auth.check()) this.$refs.reason.focus();
    else this.$refs.userEmail.focus();
  },
  beforeDestroy() {
    clearTimeout(this.endedRequestTimer);
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/variables";
@import "../../../styles/classes";

.form-control.error {
  text-align: left;
  color: red;
}

.modal {
  position: absolute;
  & .picture {
    width: 5rem;
    height: 5rem;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #ffffff;
    border-radius: 50%;
    border: 3px solid var(--pallete_main_color);
  }

  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;

    @media (min-width: 768px) {
      min-width: 350px;
    }

    & .modal-title {
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    & h3 {
      margin: 0.5rem 0;
    }

    & .footer {
      display: flex;
      justify-content: end;

      & button,
      .action {
        color: inherit;
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;

        &:hover {
          color: var(--pallete_over_main_text_color);
        }
      }

      & .action {
        padding: 0;
      }

      & .action > button {
        margin-left: 0;
      }

      & button.cancel {
        @extend %fresh-btn;

        border-radius: 0.5rem;
      }
    }
  }
}

h1 {
  text-align: center;
  margin: 50px 0 80px;
}
.share-network-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}
a[class^="share-network-"] {
  flex: none;
  color: #ffffff;
  background-color: #333;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 10px 10px 0;
}
a[class^="share-network-"] .fah {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 10px;
  flex: 0 1 auto;
}
a[class^="share-network-"] span {
  padding: 0 10px;
  flex: 1 1 0%;
  font-weight: 500;
}

.form-control {
  &.textarea {
    min-height: 50px;
    max-height: 150px;
  }
}
#reason-advice {
  margin-top: 0;
}

.btn-login:hover {
  // background-color: var(--pallete_main_color);
  // color: var(--pallete_over_main_text_color);
  background-color: var(--pallete_dark_text_color);
  color: var(--pallete_secondary_color);
  transition: all 0.3s ease-in-out;
}
</style>
